export default {
    API_URL: 'https://www.estravel.ee/api/',
    VUE_APP_ABOUT_PAGE_HTML_BASE_URL: 'https://www.estravel.ee/iseteenindus/about-pages/',
    BASE_URL: 'https://www.estravel.ee/iseteenindus/',
    AUTH_URL: 'https://auth.estravel.ee/oidc/endpoint/oidprovider/',
    AUTH_CLIENT_ID: 'extranet-front',
    AUTH_CLIENT_SECRET: '7up291inBR4T71QzcOgtt4UMboon0nEr'
}
